import axios from "@/api/axiosAuthRequired.js"
import { getAuthHeaders } from "@/api/auth"
import { BASE_URL } from "@/constants/util"
import { paramsSerializer } from "@/utils/api.utils"

export const fetchBootcamps = async ({ games, filters, page, sortOption }) => {
  try {
    const url = `${BASE_URL}bootcamps`

    const config = {
      headers: getAuthHeaders(),
      params: {
        games,
        filters,
        page,
        sort_option: sortOption,
      },
      paramsSerializer,
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const fetchFeaturedBootcamps = async () => {
  try {
    const url = `${BASE_URL}bootcamps/featured`
    const config = {
      headers: getAuthHeaders(),
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}



// WEBPACK FOOTER //
// ./src/store/bootcamp-enroll/bootcamp-enroll.apis.js